import React from 'react';
import { useRouter } from 'next/router';
import { GoHomeFill } from 'react-icons/go';
import { MdIosShare } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

import ScreenTopBar, { TopBarVariants } from 'legacy/components/ScreenTopBar';
import Button, {
  ButtonSize,
  ButtonType
} from 'legacy/common/components/button/Button';

interface Props {
  toggleMoreOptions: () => void;
  toggleShareModal: () => void;
  isDesktop: boolean;
  orgName: string;
  iconUrl: string;
  join: () => void;
  title: string;
  isUserMember: boolean;
  isUserPending: boolean;
  isUserAdmin: boolean;
}

const Header = ({
  toggleMoreOptions,
  toggleShareModal,
  isDesktop,
  orgName,
  iconUrl,
  join,
  title,
  isUserMember,
  isUserPending,
  isUserAdmin
}: Props) => {
  const router = useRouter();
  const { t } = useTranslation(['organizations', 'associations']);
  const isAssociation = router.pathname.includes('associations');

  const goBack = () => {
    router.push('/dashboard');
  };

  return (
    <>
      <ScreenTopBar
        onBack={!isDesktop ? goBack : null}
        BackIcon={GoHomeFill}
        title={title}
        scrollAnimated
        subtitle={orgName}
        variant={TopBarVariants.Big}
        onMenuClick={toggleMoreOptions}
        icon={iconUrl}
        gradientBackground
      >
        <div className="self-center flex pr-6">
          <div className="flex gap-4 justify-end">
            {isDesktop && (
              <div>
                <Button
                  onClick={toggleShareModal}
                  icon={<MdIosShare size={20} />}
                  className="text-primary-400 border-primary-400"
                  transparentBg
                  rounded
                />
              </div>
            )}
            {!isUserMember &&
              !isUserPending &&
              !isUserAdmin && (
                <div>
                  <Button
                    type={ButtonType.Primary}
                    newRadius
                    autoWidth={!isDesktop}
                    size={isDesktop ? ButtonSize.Large : ButtonSize.Small}
                    onClick={join}
                  >
                    {isAssociation
                      ? t('associations:join')
                      : t('organizations:actions.join')}
                  </Button>
                </div>
              )}
          </div>
        </div>
      </ScreenTopBar>
    </>
  );
};

export default Header;
